import { Component, ElementRef, ViewChild } from '@angular/core';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { AuthService, UserSalesLocationType } from '../services/auth.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { LanguagePipe } from '../pipes/language.pipe';
import { LanguageService } from '../services/language.service';
import { AngularFireDatabase } from '@angular/fire/compat/database';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopbarComponent {

    @ViewChild('menubutton') menuButton!: ElementRef;
    selectedSalesLocation: UserSalesLocationType;
    subscriptions = new Subscription();
    private appContextSub?: Subscription;
    appContext;
    loadingAppStatus: boolean = true;

    constructor(
        public layoutService: LayoutService,
        private authService: AuthService,
        private router: Router,
        public languagePipe: LanguagePipe,
        public languageProvider: LanguageService,
        private afDatabase: AngularFireDatabase
    ) {}

    ngOnInit() {
        this.selectedSalesLocation = this.authService.currentSalesLocationValue;
        const sub = this.authService.currentSalesLocation$.subscribe((x) => {
            this.selectedSalesLocation = x;
            const user = this.authService.currentUserValue;
            if (user && x?.salesLocationRoute) {
                localStorage.setItem(`lastUsedRoute_${user.uid}`, x.salesLocationRoute);
            }

            if (x?.salesLocationRoute) {
                this.appContextSub?.unsubscribe();
                this.appContextSub = this.afDatabase
                    .object(`Clients/${x.salesLocationRoute}/AppInfo/Context`)
                    .valueChanges()
                    .subscribe((context) => {
                        this.appContext = context;
                        this.loadingAppStatus = false;
                    });
            }
        });
        this.subscriptions.add(sub);
    }

    ngOnDestroy() {
        this.appContextSub?.unsubscribe();
        this.subscriptions.unsubscribe();
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onProfileButtonClick() {
        this.layoutService.showProfileSidebar();
    }

    getActiveUnitLabel(): string {
        if (this.selectedSalesLocation?.salesLocationName) {
            return this.selectedSalesLocation.salesLocationName;
        }
        return this.languagePipe.transform('', 'SELECT_LOCATION', this.languageProvider.currentLanguage);
    }

    NavigateToOpenCloseApp() {
        this.router.navigateByUrl(`u/${this.selectedSalesLocation.salesLocationRoute}/app`);
    }
}
